import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ecisneros';
  showButtonScroll: boolean = false;

  scrollEvent() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      this.showButtonScroll = true
    } else {
      this.showButtonScroll = false
    }
  }

  scrollsTop() {
    if (window) {
      try {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } catch (error) {
        window.scrollTo(0,0);
      }
    }
  }
}
